const formatBackendMessages = (messages: Array<{ message: { id: string; timestamp: string } }>) =>
  messages?.map((root) => {
    const { id: messageId, ...message } = root.message;

    return {
      ...root,
      message: { ...message, _id: messageId },
    };
  });

export default formatBackendMessages;
